import React from 'react';

export default function CTA() {
  return (
    <section className='py-12 md:py-24'>
      <div className='container'>
        <div className='flex flex-col md:flex-row justify-center items-center gap-6 text-center md:text-start'>
          <span className='flex-grow text-4xl md:text-5xl 2xl:text-6xl font-bold '>服务客户 <br className='hidden lg:inline' /> 助您迈向新境界</span>
          <a href="tel:15622302051" className='btn btn-secondary rounded-full sm:btn-lg'>联系我们</a>
        </div>
      </div>
    </section>
  )
}